import { GOT_SOCKET_MESSAGE, WS_CONNECTED, WS_DISCONNECTED } from '../actions/actionTypes'

export default function socket(
  state = {
    connected: false,
    messages: []
  },
  action
) {
  switch (action.type) {
    case WS_CONNECTED:
      return {
        ...state,
        connected: true
      }

    case WS_DISCONNECTED:
      return {
        ...state,
        connected: false
      }

    case GOT_SOCKET_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload]
      }

    default:
      return state
  }
}
